/**
 * Mirrors the server's permission check so the UI can hide what a user cannot
 * do. This is presentation only — the API enforces the same rules again, and
 * that is what actually protects the data.
 */
export function can(permissions, required) {
  if (!Array.isArray(permissions) || !permissions.length) return false;
  if (permissions.includes('*')) return true;
  if (permissions.includes(required)) return true;
  // A `manage` permission implies every action on that resource.
  const [resource] = required.split(':');
  return permissions.includes(`${resource}:manage`);
}

export const canAny = (permissions, list) => list.some((p) => can(permissions, p));
export const canAll = (permissions, list) => list.every((p) => can(permissions, p));
